import React, { useState, useEffect } from "react";
import axios from "../../utils/axiosInstance";
import CommonModalForm from "../../components/commonComponent/CommonModalForm";
import { toastSuccess, toastError } from '../../utils/alertHelper';
import { FaEdit } from 'react-icons/fa';


export default function PricingPlans() {
  const [responsibilitiesList, setResponsibilitiesList] = useState([]);
  const [responsibilityData, setResponsibilityData] = useState([]);
  const [plans, setPlans] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    name: "",
    duration: "",
    price: "",
    gstPercentage: "",
    // PlanResponsibility: [],
  });

  // Fetch responsibilities
  useEffect(() => {
    async function fetchResponsibilities() {
      try {
        const res = await axios.get("/api/plan-responsibilities");
        const options = (res.data?.planResponsibilities || []).map((r) => ({
          value: r._id,
          label: r.name,
        }));
        setResponsibilitiesList(options);
        setResponsibilityData(res.data?.planResponsibilities || []);
      } catch (err) {
        setResponsibilitiesList([]);
        setResponsibilityData([]);
      }
    }
    fetchResponsibilities();
  }, []);

  // Fetch plans
  useEffect(() => {
    fetchPlans();
  }, []);

  const fetchPlans = async () => {
    try {
      const res = await axios.get("/api/plan");
      if (Array.isArray(res.data?.plans)) {
        setPlans(res.data.plans);
      } else if (res.data?.plan) {
        setPlans([res.data.plan]);
      } else {
        setPlans([]);
      }
    } catch (err) {
      setPlans([]);
    }
  };

  // Add new plan
  const handleShowAddForm = () => {
    setEditMode(false);
    setFormData({
      id: null,
      name: "",
      duration: "",
      price: "",
      gstPercentage: "",
      // PlanResponsibility: [],
    });
    setShowForm(true);
  };

  // Edit existing plan
  const handleEditPlan = (plan) => {
    let ids = [];
    if (Array.isArray(plan.PlanResponsibility)) {
      ids = plan.PlanResponsibility.map((r) =>
        typeof r === "string" ? r : r._id || r
      );
    } else if (
      typeof plan.PlanResponsibility === "string" &&
      plan.PlanResponsibility.length > 0
    ) {
      ids = plan.PlanResponsibility.split(",");
    }

    setFormData({
      id: plan._id || plan.id,
      name: plan.name || "",
      duration: plan.duration || "",
      price: plan.price || "",
      gstPercentage: plan.gstPercentage || "",
      // PlanResponsibility: ids, 
    });
    setEditMode(true);
    setShowForm(true);
  };

  const handleFormChange = (newValues) => {
    setFormData(newValues);
  };

  // Submit (Add / Update)
  const handleFormSubmit = async () => {
    try {
      let planResponsibilityValue = formData.PlanResponsibility;
      if (Array.isArray(planResponsibilityValue)) {
        planResponsibilityValue = planResponsibilityValue.join(",");
      }

      const payload = {
        name: formData.name,
        duration: formData.duration,
        price: Number(formData.price),
        gstPercentage: formData.gstPercentage,
        // PlanResponsibility: planResponsibilityValue,
      };

      if (editMode && formData.id) {
        await axios.put(`/api/plan/${formData.id}`, payload);
        toastSuccess('Plan updated successfully!');
      } else {
        await axios.post("/api/plan", payload);
        toastSuccess('Plan added successfully!');
      }

      await fetchPlans();
      setShowForm(false);
    } catch (err) {
      let message = 'Error saving plan';
      if (err.response && err.response.data) {
        if (err.response.data.message) {
          message = err.response.data.message;
        } else if (err.response.data.error) {
          message = err.response.data.error;
        }
      }
      toastError(message);
      console.error("Error saving plan:", err);
    }
  };

  const handleCancelForm = () => {
    setShowForm(false);
  };

  // Render responsibility names
      const renderResponsibilities = (plan) => {
      let ids = [];
      if (Array.isArray(plan.PlanResponsibility)) {
        ids = plan.PlanResponsibility.map((r) =>
          typeof r === "string" ? r : r._id || r
        );
      } else if (
        typeof plan.PlanResponsibility === "string" &&
        plan.PlanResponsibility.length > 0
      ) {
        ids = plan.PlanResponsibility.split(",");
      }

      const names = ids
        .map((id) => {
          const found = responsibilityData.find((r) => r._id === id);
          return found ? found.name : id;
        })
        .filter(Boolean);

      return (
        <div className="d-flex flex-wrap">
          {names.map((name, i) => (
            <div
              key={i}
              className="d-flex align-items-center mb-1"
              style={{ width: "50%" }} // 2 columns
            >
              ✅ <span className="ms-1">{name}</span>
            </div>
          ))}
        </div>
      );
    };

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-sm">
          <div className="row">
            <div className="col-12 d-flex justify-content-between align-items-center mb-3">
              <h4 className="mb-0 font-size-24 fw-bold text-gradient">
                Pricing Plans
              </h4>
              {/* <button
                              className="btn btn-success btn-rounded px-4"
                              onClick={handleShowAddForm}
                            >
                              + Add Plan
                            </button> */}
            </div>
          </div>

          {/* Common Modal Form */}
          <CommonModalForm
            visible={showForm}
            title={editMode ? "Edit Plan" : "Add New Plan"}
            fields={[
              {
                name: "name",
                label: "Plan Name",
                type: "text",
                placeholder: "Plan Name",
                required: true,
              },
              {
                name: "duration",
                label: "Year",
                type: "number",
                placeholder: "Year",
                required: true,
              },
              {
                name: "price",
                label: "Price",
                type: "number",
                placeholder: "Price",
                required: true,
              },
              {
                name: "gstPercentage",
                label: "GST (%)",
                type: "number",
                placeholder: "GST (%)",
                required: true,
              },
              
            ]}
            values={formData}
            onChange={handleFormChange}
            onCancel={handleCancelForm}
            onSubmit={handleFormSubmit}
            submitLabel={editMode ? "Update" : "Add"}
            cancelLabel="Cancel"
            requiredFields={[
              "name",
              "duration",
              "price",
              "gstPercentage",
              /*"PlanResponsibility",*/
            ]}
          />

          {/* Plans Grid (no carousel) */}
          {plans.length === 0 ? (
            <div className="text-center py-5">
              <p className="text-muted">No plans added yet.</p>
            </div>
          ) : (
            <div className="row g-3">
              {plans.map((plan) => (
                <div
                  key={plan._id || plan.id}
                  className="col-12 col-sm-6 col-md-4 d-flex align-items-stretch"
                >
                  <div
                      className="card shadow-sm border-0 rounded-3 w-100"
                      style={{
                        background: "linear-gradient(135deg, #ffffff, #ffffff)",
                        color: "#000",
                        minHeight: 180, // smaller height
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                     <button
                        className="btn btn-success btn-sm btn-rounded fw-bold position-absolute"
                        style={{ top: "0.8rem", right: "0.5rem" }}
                        onClick={() => handleEditPlan(plan)}
                      >
                        <FaEdit />
                      </button>
                      <div className="card-body d-flex flex-column p-3">
                        <div>
                          <h5 className="fw-bold text-uppercase mb-2">{plan.name}</h5>
                          <h6 className="fw-bold mb-1">₹{plan.price} + GST {plan.gstPercentage}%</h6>
                          <p className="mb-2" style={{ fontSize: '0.85rem' }}>
                            Duration: {plan.duration} year(s)
                          </p>
                          {/* <div
                                                      className="bg-white rounded p-2 text-dark"
                                                      style={{ minHeight: 60 }} // smaller responsibility box
                                                    >
                                                      {renderResponsibilities(plan)}
                                                    </div> */}
                        </div>
                      </div>
                    </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
